import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { Note } from '@/Domain/api/Conversation/dto/Note.dto';

type Props = {
  note: Note;
};

export const NoteItem = ({ note }: Props) => {
  const { t } = useTranslation('inbox_v2');

  return (
    <li className="grid grid-cols-[min-content_1fr] gap-3.5 p-4 border border-border text-foreground-subtle rounded-xl text-sm w-fit self-center">
      <Icon icon="mingcute:chat-1-line" className="mt-0.5 text-primary text-base" />
      <div className="flex flex-col">
        <p className="text-sm font-semibold text-foreground mb-1">{t('ai_note')}</p>
        <span dangerouslySetInnerHTML={{ __html: note.description }} />
      </div>
    </li>
  );
};
